/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Dropdown, DropdownToggle, DropdownMenu,
} from 'reactstrap';

import { withTranslation } from 'react-i18next';

// Import images
import zebraIcon from '../../../assets/images/zebra-30.png';

import { get } from '../../../helpers/api_helper';

const truncateMiddle = (value, maxLength = 17) => {
  if (!value || value.length <= maxLength) return value;

  const ellipsis = '...';
  const keepLength = maxLength - ellipsis.length;
  const frontLength = Math.ceil(keepLength / 2);
  const backLength = Math.floor(keepLength / 2);

  return `${value.slice(0, frontLength)}${ellipsis}${value.slice(-backLength)}`;
};

function ZebraDropdown(props) {
  const { t } = props;

  const [menu, setMenu] = useState(false);
  const [zebras, setZebras] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState(localStorage.getItem('selectedPrinter'));

  // eslint-disable-next-line no-unused-vars
  const user = JSON.parse(localStorage.getItem('authUser'));

  const toggle = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = await get('/api/zebra?rpp=100');

      setZebras(result.results);
    };

    if (menu) fetchData();
  }, [menu]);

  const handleSelectPrinter = (id) => {
    setSelectedPrinter(id.toString());
    localStorage.setItem('selectedPrinter', id.toString());
  };

  return (
    <Dropdown
      isOpen={menu}
      toggle={toggle}
      className="dropdown d-inline-block"
      tag="li"
    >
      <DropdownToggle
        className="btn header-item noti-icon position-relative"
        tag="button"
        id="page-header-notifications-dropdown"
        title={t('Zebra Printer')}
      >
        <img src={zebraIcon} style={{ width: '18px' }} alt={t('Zebra Printer')} />
        {selectedPrinter === null && (
          <span className="badge bg-warning rounded-pill">
            <span className="mdi mdi-close-thick" />
          </span>
        )}
        {selectedPrinter !== null && (
          <span className="badge bg-success rounded-pill">
            <span className="mdi mdi-check" />
          </span>
        )}
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu dropdown-menu-md dropdown-menu-end p-0" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
        <div>
          {zebras.length === 0 && (
            <div className="p-3 text-center">{t('Loading...')}</div>
          )}
          {zebras.length > 0 && (
            <div>
              {zebras.map((zebra) => (
                <div key={zebra.id} className="pb-0 pt-2 pe-3 ps-3" style={{ minHeight: '30px' }}>
                  <div className="float-end" style={{ marginTop: '7px' }}>
                    <a href="#" onClick={() => handleSelectPrinter(zebra.id)} style={{ color: '#484848', fontSize: '17px' }} title={zebra.name.toUpperCase()}>{truncateMiddle(zebra.name.toUpperCase())}</a>
                  </div>
                  {selectedPrinter === zebra.id.toString() && (
                    <li className="position-relative">
                      <span className="mdi mdi-printer-pos" style={{ fontSize: '25px' }} />
                      <span className="badge bg-success rounded-pill position-absolute" style={{ top: '2px', left: '17px' }}>
                        <span className="mdi mdi-check" />
                      </span>
                    </li>
                  )}
                  {selectedPrinter !== zebra.id.toString() && (
                    <li>
                      <span className="mdi mdi-printer-pos" style={{ fontSize: '25px' }} />
                    </li>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </DropdownMenu>
    </Dropdown>
  );
}

ZebraDropdown.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(ZebraDropdown);
